import {
  Droplets, Truck, Gauge, Factory, CarFront, Cog, Disc3, BatteryCharging,
  CalendarCheck, MapPin,
} from "lucide-react";

export const CONTACT = {
  phone: "403-929-1800",
  phoneHref: "tel:+14039291800",
  email: "luigilube@hotmail.com",
  emailHref: "mailto:luigilube@hotmail.com",
  area: "Lethbridge, Alberta",
  rating: "5.0",
  reviews: 7,
};

export const BRANDS = ["Mobil 1", "Castrol", "AMSOIL", "Pennzoil", "Valvoline", "Shell"];

export const STATS = [
  { value: 5.0, suffix: "", label: "Star Rating", decimals: 1 },
  { value: 20, suffix: "min", label: "Average Service" },
  { value: 100, suffix: "%", label: "Mobile — We Come To You" },
  { value: 7, suffix: "+", label: "Five-Star Reviews" },
];

export const SERVICES = [
  {
    id: "blend",
    icon: Gauge,
    tag: "$79.99",
    title: "Synthetic Blend Oil Change",
    desc: "The sweet spot of protection and value for everyday driving and daily commuters.",
    points: ["Synthetic-blend oil", "New filter", "Multi-point inspection", "Fluid top-up"],
  },
  {
    id: "synthetic",
    icon: Droplets,
    tag: "Most Popular · $89.99",
    title: "Full Synthetic Oil Change",
    desc: "Maximum protection and performance for modern and high-mileage engines, at your door.",
    points: ["Premium full-synthetic oil", "New OEM-grade filter", "Multi-point inspection", "All fluids topped up"],
  },
  {
    id: "euro",
    icon: CarFront,
    tag: "$109.99",
    title: "European Car Oil Change",
    desc: "Specialty oils and filters tuned for European makes — BMW, Mercedes, Audi, VW and more.",
    points: ["Euro-spec synthetic oil", "OEM-grade filter", "Spec-correct service", "Multi-point inspection"],
  },
  {
    id: "diesel",
    icon: Truck,
    tag: "from $149.99",
    title: "Diesel Oil Change",
    desc: "Specialized diesel-grade oils and filters for trucks and heavy-duty vehicles.",
    points: ["Diesel-spec oil", "Heavy-duty filter", "Inspection report"],
  },
  {
    id: "transmission",
    icon: Cog,
    tag: "from $149.99",
    title: "Transmission Drain & Fill",
    desc: "Refresh your transmission fluid to keep shifting smooth and protect your drivetrain.",
    points: ["Drain & fill service", "Spec-correct fluid", "Leak & level check"],
  },
  {
    id: "driveline",
    icon: Disc3,
    tag: "from $99.99",
    title: "Driveline Service",
    desc: "Differential and driveline fluid service to keep power flowing smoothly to your wheels.",
    points: ["Driveline fluid service", "Inspection", "We come to you"],
  },
  {
    id: "battery",
    icon: BatteryCharging,
    tag: "Sales & Install",
    title: "Battery Replacement",
    desc: "We sell and install new batteries on-site — no jump-starts or tow needed.",
    points: ["New battery supply", "On-site installation", "Old battery disposal", "Charging-system check"],
  },
  {
    id: "fleet",
    icon: Factory,
    tag: "Business",
    title: "Fleet & Commercial",
    desc: "Keep your whole fleet rolling. On-site scheduled servicing with zero downtime at the shop.",
    points: ["Volume pricing", "On-site scheduling", "Service records"],
  },
];

export const PROCESS = [
  { n: "01", icon: CalendarCheck, title: "Book Online", desc: "Pick a date and arrival window and tell us your vehicle. Takes under 60 seconds." },
  { n: "02", icon: MapPin, title: "We Come To You", desc: "Home, office or driveway — our mobile unit arrives fully prepared." },
  { n: "03", icon: Droplets, title: "Premium Service", desc: "Fresh oil, new filter and a multi-point inspection in ~20 minutes." },
  { n: "04", icon: CarFront, title: "Drive Away", desc: "No waiting rooms, no shop. Just a smoother, protected vehicle." },
];

// Oil-change pricing tiers
export const PRICING = [
  {
    name: "Synthetic Blend",
    price: "79.99",
    from: false,
    tagline: "Everyday protection",
    featured: false,
    features: ["Synthetic-blend oil & filter", "Multi-point inspection", "Fluid top-up", "We come to you", "Service in ~20 min"],
  },
  {
    name: "Full Synthetic",
    price: "89.99",
    from: false,
    tagline: "Maximum protection",
    featured: true,
    features: ["Premium full-synthetic oil", "OEM-grade filter", "Multi-point inspection", "All fluids topped up", "Priority scheduling", "We come to you"],
  },
  {
    name: "European Car",
    price: "109.99",
    from: false,
    tagline: "Specialty vehicles",
    featured: false,
    features: ["Euro-spec synthetic oil", "OEM-grade filter", "Spec-correct service", "Multi-point inspection", "We come to you"],
  },
  {
    name: "Diesel",
    price: "149.99",
    from: true,
    tagline: "Heavy-duty engines",
    featured: false,
    features: ["Diesel-spec oil & filter", "Heavy-duty service", "Inspection report", "We come to you"],
  },
];

// Additional services (non oil-change)
export const ADDONS = [
  { icon: Cog, title: "Transmission Drain & Fill", price: "from $149.99", desc: "Refresh transmission fluid for smooth, protected shifting." },
  { icon: Disc3, title: "Driveline Service", price: "from $99.99", desc: "Differential & driveline fluid service, done at your location." },
  { icon: BatteryCharging, title: "Battery Replacement", price: "Sales & install", desc: "We supply and install new batteries on-site." },
];

export const TESTIMONIALS = [
  {
    name: "Gursahib Singh",
    role: "Verified Google Review",
    rating: 5,
    text: "I recently used Luigi Lube's mobile oil change service, and it was fantastic! They came right to my location on time, fully prepared, and got the job done quickly and professionally. Super convenient and hassle-free — no waiting at a shop.",
  },
  {
    name: "Manav",
    role: "Verified Google Review",
    rating: 5,
    text: "Quick, professional and unbelievably convenient. Booked in the morning and my oil change was done in my own driveway by lunch. Couldn't recommend Luigi Lube more.",
  },
  {
    name: "Daniel R.",
    role: "Lethbridge",
    rating: 5,
    text: "No more wasting a Saturday at the shop. They showed up on time, were tidy, and the whole thing took half an hour. This is how oil changes should be.",
  },
  {
    name: "Priya K.",
    role: "Lethbridge",
    rating: 5,
    text: "Fully prepared, polite and fast. Great communication from booking to finish. Luigi Lube has earned a customer for life.",
  },
];

export const FAQS = [
  { q: "How does a mobile oil change work?", a: "You book online, and our fully-equipped mobile unit comes to your home, office or anywhere in Lethbridge. We perform the complete service on-site — no shop, no waiting room, no hassle." },
  { q: "How long does it take?", a: "Most services are completed in about 20 minutes once we arrive. You can keep working or relaxing while we handle everything." },
  { q: "What areas do you serve?", a: "We proudly serve Lethbridge, Alberta and the surrounding area. Not sure if you're in range? Send us a message and we'll confirm." },
  { q: "What types of oil do you use?", a: "We use premium, manufacturer-approved oils from trusted brands like Mobil 1, Castrol, AMSOIL, Pennzoil, Valvoline and Shell — in conventional, synthetic blend and full synthetic, plus diesel-specific options. We'll recommend the right one for your vehicle." },
  { q: "Do you service fleets and businesses?", a: "Absolutely. We offer on-site fleet servicing with volume pricing and scheduling that keeps your vehicles on the road, not in a shop." },
  { q: "How do I pay?", a: "Payment is collected after the service is complete. Reach out at booking and we'll walk you through the options." },
];
